import React from 'react';
import { useDispatch } from 'react-redux';
import {
  If,
  replaceEURinValueSet,
  Produktbaustein,
  FormCombobox,
  FormSlider,
  appActions,
  useUpdateByNameAndBerechneOnChange,
  Bike,
  findValueById,
} from 'ion-lib';
import i18next from 'i18next';

const Fahrraddiebstahl = ({
  baustein,
  bausteinIndex,
  handleChange,
  fahrradmax,
  fahrradwert,
  handleChangeWert,
}) => {
  const dispatch = useDispatch();
  const berechneOnChangeByName = useUpdateByNameAndBerechneOnChange(500);
  const sliderHandle = (name, value) => {
    berechneOnChangeByName(name, fahrradwert.valueSet[value - 1].id);
  };

  return (
    baustein.relevant && (
      <Produktbaustein
        title={i18next.t('produktvergleich.zusatz.fahrraddiebstahl_title')}
        tooltip={() => dispatch(appActions.toggleModal(i18next.t('produktvergleich.zusatz.fahrraddiebstahl_tt')))}
        onChange={handleChange}
        name={`daten.bausteine.${bausteinIndex}.fahrraddiebstahl.value`}
        checkbox={baustein}
      >
        <p dangerouslySetInnerHTML={{ __html: i18next.t('produktvergleich.zusatz.fahrraddiebstahl_beschreibung') }} />
        <If predicate={fahrradmax.relevant && fahrradwert.relevant}>
          <p>
            Sie können Ihre Fahrräder bis zu einem Wert von
            {' '}
            {parseFloat(fahrradmax.value).toLocaleString('de-DE')}
            {' '}
            € gegen Diebstahl absichern.
          </p>
          <FormCombobox
            {...fahrradwert}
            title="Bitte wählen Sie den Wert Ihres Fahrrades bzw. Ihrer Fahrräder aus:"
            name={`daten.bausteine.${bausteinIndex}.fahrraddiebstahlWert.value`}
            className="produktbaustein__auswahl"
            onChange={handleChangeWert}
            valueSet={replaceEURinValueSet(fahrradwert.valueSet)}
          />
          <FormSlider
            {...fahrradwert}
            label="Bitte wählen Sie den Wert Ihres Fahrrades bzw. Ihrer Fahrräder mit dem Schieberegler aus:"
            labelClassName="visually-hidden"
            onChange={sliderHandle}
            name={`daten.bausteine.${bausteinIndex}.fahrraddiebstahlWert.value`}
            className="mt-3"
            slider={{
              min: 1,
              max: 18,
              number: bausteinIndex,
              handleStyle: {
                width: '40px',
                height: '40px',
                marginTop: '-21px',
              },
            }}
            tooltipStyle={{
              whiteSpace: 'nowrap',
            }}
            tooltipText={findValueById(replaceEURinValueSet(fahrradwert.valueSet), parseInt(fahrradwert.value, 10))}
            icon={<Bike />}
            showFirstLastDots
            value={fahrradwert.relevant && fahrradwert.valueSet.findIndex((value) => value.id === parseInt(fahrradwert.value, 10)) + 1}
          />
        </If>
      </Produktbaustein>
    )
  );
};

export default Fahrraddiebstahl;
